import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { TagMenuItemProps, TagMenuProps } from './tag.types';
import { Tag, addStyles } from '../..';

const style = {
  container: 'flex flex-col shadow rounded overflow-hidden inline-block relative',
};

const itemStyles = {
  base: 'box-border cursor-pointer leading-6 px-2 py-1 border border-1 border-solid hover:bg-gray-50 hover:border-gray-100',
  unselected: 'border-white bg-white focus:bg-white focus:border-gray-900',
  selected: 'bg-gray-50 border-gray-50',
};
const TagMenuItem = (props: TagMenuItemProps) => {
  const { item, onSelect } = props;
  const defaultSelected = Boolean(item?.isSelected);
  const [isSelected, setIsSelected] = useState<boolean>(defaultSelected);
  const ref = useRef<HTMLDivElement>(null);
  const itemValue = JSON.stringify(item);

  useEffect(() => {
    setIsSelected(defaultSelected);
  }, [itemValue, defaultSelected]);

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      onSelect(item);
      setIsSelected((curr) => !curr);
      e.stopPropagation();
    },
    [item, onSelect]
  );

  return (
    <div
      role="menuitem"
      tabIndex={0}
      ref={ref}
      onClick={onClick}
      className={addStyles([itemStyles.base, itemStyles[isSelected ? 'selected' : 'unselected']])}
    >
      <span className="select-none">{<Tag onClick={onClick} {...item.tag} />}</span>
    </div>
  );
};

export const TagMenu = (props: TagMenuProps) => {
  const { options, onSelect, selected, width, containerClassName } = props;

  const menuItems = useMemo(() => {
    return options.map((option) => {
      const isSelected = selected === option.value;
      return { ...option, isSelected, label: option.tag.text };
    });
  }, [options, selected]);

  return (
    <div className={containerClassName ?? style.container} style={{ width: width, maxWidth: width }}>
      {menuItems.map((item) => (
        <TagMenuItem key={item.value} item={item} onSelect={onSelect} />
      ))}
    </div>
  );
};

export default TagMenu;
